// The words of the org the builder authors for, for every card inside it, the
// payout words of the template it writes, and the mark its money is written
// with.

import { createContext, useContext } from 'solid-js';

import type { OrgWords, PayoutWords } from '../core/ruleText';

/** `payout`: the payouts of the template the builder writes. They follow the
 *  settlement it is sold under (`TEMPLATE_SETTLEMENT`), never the org it is
 *  for; the builder renders only once both read. `mark`: the mark of the
 *  currency the template is priced in ("$", "EUR"), beside every amount the
 *  author types. */
export interface BuilderWords {
  org: OrgWords;
  payout: PayoutWords;
  mark: string;
}

export const BuilderWordsContext = createContext<BuilderWords>();

function builderWords(): BuilderWords {
  const words = useContext(BuilderWordsContext);
  if (!words) throw new Error('The builder renders without its words.');
  return words;
}

/** The builder's org's words; the builder always provides them. */
export function useOrgWords(): OrgWords {
  return builderWords().org;
}

/** The payout words of the template the builder writes. */
export function useTemplatePayoutWords(): PayoutWords {
  return builderWords().payout;
}

/** The mark the template's money is written with: its currency's. */
export function useMoneyMark(): string {
  return builderWords().mark;
}
